/**
 * Register Page Loader
 * Checks authentication state and tracks page load
 */

import { redirect, type LoaderFunctionArgs } from 'react-router-dom';
import {
  trackRouteLoad,
  trackRouteError,
  startRouteTimer,
  calculateDataSize,
} from '@/utils/route-analytics';

export interface RegisterData {
  redirectUrl?: string;
  referralCode?: string;
}

/**
 * Register loader function
 * Redirects to dashboard if already authenticated
 */
export async function registerLoader(args: LoaderFunctionArgs) {
  const getElapsed = startRouteTimer();

  try {
    // Check if user is already logged in
    const token = localStorage.getItem('token');
    if (token) {
      // User is already authenticated, redirect to dashboard
      return redirect('/dashboard');
    }

    // Get any referral code or redirect URL from search params
    const url = new URL(args.request.url);
    const referralCode = url.searchParams.get('ref') ?? undefined;
    const redirectUrl = url.searchParams.get('redirect') ?? undefined;

    const data: RegisterData = {
      redirectUrl,
      referralCode,
    };

    // Track performance
    const loadTime = getElapsed();
    const dataSize = calculateDataSize(data);
    trackRouteLoad('/register', loadTime, dataSize);

    // Return data directly (React Router loaders don't need to be wrapped)
    return data;
  } catch (error) {
    // If it's a redirect Response, let it propagate
    if (error instanceof Response) {
      throw error;
    }

    trackRouteError('/register', error as Error);
    throw error;
  }
}
